import type { PlatformRoleSpec } from '../../identityxp/framework';

type Props = {
  roles: PlatformRoleSpec[];
};

export function RoleBadgeGrid({ roles }: Props) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {roles.map((r) => (
        <div key={r.role} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="font-medium text-slate-900 dark:text-slate-100">{r.label}</p>
          {r.description && <p className="mt-1 text-xs text-slate-500">{r.description}</p>}
          {r.default_home && (
            <p className="mt-2 font-mono text-xs text-brand-600 dark:text-brand-400">{r.default_home}</p>
          )}
        </div>
      ))}
    </div>
  );
}
